/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHosportsRetailerLoginData } from './hosports-retailer-login.data';
import { IHosportsRetailerLoginProps } from './hosports-retailer-login.props.autogenerated';

export interface IHosportsRetailerLoginViewProps extends IHosportsRetailerLoginProps<IHosportsRetailerLoginData> {}

/**
 *
 * HosportsRetailerLogin component
 * @extends {React.PureComponent<IHosportsRetailerLoginProps<IHosportsRetailerLoginData>>}
 */
class HosportsRetailerLogin extends React.PureComponent<IHosportsRetailerLoginProps<IHosportsRetailerLoginData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HosportsRetailerLogin;
